import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=1e11b6d7&scoped=true&"
import script from "./FrontPage.vue?vue&type=script&lang=js&"
export * from "./FrontPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e11b6d7",
  null
  
)

export default component.exports